import { AdapterInterface, AdapterCdoMceInterface, AdapterCdoLn1Interface } from "../interfaces/Adapter.interface";
import { AdapterCdoModbusInterface } from "../interfaces/AdapterCdoModbus.interface";
import { AdapterCdoOpcInterface } from "../interfaces/AdapterCdoOpc.interface";
import { AdapterCdoSequentInterface } from "../interfaces/AdapterCdoSequent.interface";
import { AdapterBacnetInterface, BacnetLn2Mapping } from "../interfaces/AdapterCdoBacnet.interface";

export const BLANK_ADAPTER_CDO_MCE: AdapterCdoMceInterface = {
	idl_file: "",
	product_type: 0,
	event: {
		reporting_address: "",
		mapping_file: "",
		mapping_data: "",
	},
};

export const BLANK_ADAPTER_CDO_MODBUS: AdapterCdoModbusInterface = {
	slave_id: 1,
	polling_interval: 1000,
	ln2_to_msg_map: [
		{
			key: {
				msg: {
					msg: {
						content: {
							one_hot_message: {
								message: {
									usage_message: {
										message: {
											elevator_usage_message: { message: {} },
										},
									},
								},
							},
						},
					},
					active: true,
				},
				bank_name: "Bank A",
				lift_name: "Lift 1",
				bank_id: "11111111-1111-1111-1111-111111111111",
				lift_id: "22222222-2222-2222-2222-222222222222",
			},
			val: {
				message: {
					kind: "ReadHoldingRegistersRequest",
					address: 0x0000,
					quantity: 4,
				},
			},
		},
		{
			key: {
				msg: {
					msg: {
						content: {
							one_hot_message: {
								message: {
									service_message: {
										message: {
											elevator_service_message: { message: {} },
										},
									},
								},
							},
						},
					},
					active: false,
				},
				bank_name: "Bank A",
				lift_name: "Lift 1",
				bank_id: "11111111-1111-1111-1111-111111111111",
				lift_id: "22222222-2222-2222-2222-222222222222",
			},
			val: {
				message: {
					kind: "WriteSingleRegisterRequest",
					address: 0x0010,
					value: 1234,
				},
			},
		},
	],
	msg_to_ln2_map: [
		{
			key_2: 0,
			key_1: {
				message: {
					kind: "ReadHoldingRegistersResponse",
					data: [100, 200, 300, 400],
				},
			},
			val: {
				msg: {
					msg: {
						content: {
							bit_mask_message: {
								message: {
									status_message: {},
								},
							},
						},
					},
					active: true,
				},
				bank_name: "Bank A",
				lift_name: "Lift 1",
				bank_id: "11111111-1111-1111-1111-111111111111",
				lift_id: "22222222-2222-2222-2222-222222222222",
			},
		},
		{
			key_2: 0,
			key_1: {
				message: {
					kind: "WriteSingleRegisterResponse",
					address: 0x0010,
					value: 1234,
				},
			},
			val: {
				msg: {
					msg: {
						content: {
							bit_mask_message: {
								message: {
									controller_info_message: {},
								},
							},
						},
					},
					active: true,
				},
				bank_name: "Bank A",
				lift_name: "Lift 1",
				bank_id: "11111111-1111-1111-1111-111111111111",
				lift_id: "22222222-2222-2222-2222-222222222222",
			},
		},
	],
};

export const BLANK_ADAPTER_CDO_OPC: AdapterCdoOpcInterface = {
	opc_server: "",
	hostname: "",
	location: {
		name: "",
		sites: [],
	},
	sites: {
		opc_cmd_to_msg: [],
		msg_to_opc_cmd: [],
		opc_cmd_to_sequence: [],
	},
	locations: {
		opc_cmd_to_msg: [],
		msg_to_opc_cmd: [],
		opc_cmd_to_sequence: [],
	},
	car_num_to_name: [],
	groups: {
		mappings: {
			opc_cmd_to_msg: [],
			msg_to_opc_cmd: [],
			opc_cmd_to_sequence: [],
		},
		path_only: { mappings: { opc_cmd_to_msg: [], msg_to_opc_cmd: [], opc_cmd_to_sequence: [] } },
		data_only: { mappings: { opc_cmd_to_msg: [], msg_to_opc_cmd: [], opc_cmd_to_sequence: [] } },
		path_and_data: { mappings: { opc_cmd_to_msg: [], msg_to_opc_cmd: [], opc_cmd_to_sequence: [] } },
	},
	lifts: {
		mappings: {
			opc_cmd_to_msg: [],
			msg_to_opc_cmd: [],
			opc_cmd_to_sequence: [],
		},
		path_only: { mappings: { opc_cmd_to_msg: [], msg_to_opc_cmd: [], opc_cmd_to_sequence: [] } },
		data_only: { mappings: { opc_cmd_to_msg: [], msg_to_opc_cmd: [], opc_cmd_to_sequence: [] } },
		path_and_data: { mappings: { opc_cmd_to_msg: [], msg_to_opc_cmd: [], opc_cmd_to_sequence: [] } },
	},
};

export const BLANK_ADAPTER_CDO_BACNET: AdapterBacnetInterface = {
	entries: [],
};

export const BLANK_ADAPTER_CDO_SEQUENT: AdapterCdoSequentInterface = {
	discrete_2_message: [],
	dev_type: 0,
};

export const BLANK_ADAPTER_CDO_LN1: AdapterCdoLn1Interface = {
	terminating_zeroes_expected: {
		from_device_serial: 0,
		refresh_all: 0,
		set_one_bit: 0,
		reinitialize_all_devices: 0,
		set_one_byte: 0,
		rvu: 0,
		rvu_heartbeat: 0,
	},
	crc_override: false,
	should_filter_duplicates: false,
	allowed_messages: 0,
};

export const BLANK_ADAPTER: AdapterInterface = {
	created_at: "2024-04-22T20:08:33.235602Z",
	updated_at: "2025-02-18T19:19:02.146561Z",
	server_id: null,
	deleted_at: null,
	name: "CEC-Swift-3C16F",
	version: "1.0.0",
	auth_credentials: {
		username: "",
		password: "",
	},
	socket_address: "127.0.0.1:1234",
	auth_type: "PASSWORD",
	type: "WEBSOCKET",
	protocol_type: "",
	lift_type: "ELEVATOR",
	dictionary: {},
	interface: {},
	keys: [],
	total_bacnet_channels: 0,
	id: "",
	active: true,
	units: 1,
	offset_mapping: [],
	protocol_id: "",
	leading_zeroes_id: "",
	floors: 1,
	action_catalogs: [],
	cdo_input: BLANK_ADAPTER_CDO_MCE,
	socket_message_priority: {
		customConfiguration: true,
		rules: [],
	},
};

export const DEFAULT_BACNET_LN2_MAPPING: BacnetLn2Mapping = {
	point: {
		host_name: "",
		point_name: "",
		group_name: "",
		host_id: "",
		group_id: "",
		value: 0,
		point_id: 0,
		bank_name: "",
		bank_id: "",
		lift_id: "",
		lift_name: "",
	},
	ln2_msg: {
		msg_id: "",
		position: 1,
		active: true,
	},
};
